var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"wrap":""}},[_c('v-layout',[_c('v-flex',{attrs:{"text-xs-center":""}},[_vm._v(" 404 - Not Found ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }